import { render, staticRenderFns } from "./PrintSubmission.vue?vue&type=template&id=1671e143&scoped=true"
import script from "./PrintSubmission.vue?vue&type=script&lang=ts"
export * from "./PrintSubmission.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1671e143",
  null
  
)

export default component.exports